import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { parseNumberByPrecision } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { PlayerHand } from '../../components';
import { cardsStore } from '../../store/cardsStore';
import { doBetStore } from '../../store/doBetStore';
import { gameStore } from '../../store/gameStore';
import { mathConfig, mathJS } from '../../helpers/mathFormat';

const PlayerHands = observer(() => {
  const { playerCards } = cardsStore;
  const { lastBetModel, sideBetsInfo } = doBetStore;
  const { isInsuranceLose } = gameStore;
  const { precision } = userInfoStore;

  const boxAmountByBetType = useMemo(() => {
    const { betModel } = lastBetModel;
    if (betModel) {
      return betModel.reduce((modelByBox, currentBox) => {
        modelByBox[currentBox.boxIndex] = currentBox.markets.reduce(
          (modelByBetType, currentBetType) => {
            modelByBetType[currentBetType.type] = {
              ...currentBetType,
              // eslint-disable-next-line no-nested-ternary
              amount: currentBetType.hasOwnProperty('winAmount')
                ? currentBetType.winAmount
                  ? currentBetType.winAmount
                  : 0
                : parseNumberByPrecision(
                    1,
                    +mathJS.format(
                      currentBetType.amount +
                        (!isInsuranceLose ? currentBetType.insuranceAmount || 0 : 0),
                      mathConfig
                    ),
                    +precision
                  ),
            };
            return modelByBetType;
          },
          {}
        );
        return modelByBox;
      }, {});
    }
    return {};
  }, [precision, lastBetModel, isInsuranceLose]);

  return (
    <div className='tb-player-seats'>
      {[...playerCards].reverse().map((boxInfo) => {
        return (
          <PlayerHand
            boxInfo={boxInfo}
            key={boxInfo.boxIndex}
            boxAmountByBetType={boxAmountByBetType && boxAmountByBetType[boxInfo.boxIndex]}
            sideBetsInfo={sideBetsInfo[boxInfo.boxIndex]}
          />
        );
      })}
    </div>
  );
});

export default PlayerHands;
